import { Commit, ActionTree, Dispatch } from 'vuex';
import { State } from '@/store/modules/synthetics/commonState/commonState.store';
import { AxiosResponse } from 'axios';
import graphQl from '@/services/graphQl';
import graphHelpers from '@/utils/graphHelper';
import { Context, Params } from '@/utils/types/global';
import getEnv from '@/utils/env';
import { SM_FALLBACK_IP } from '@/utils/constants';
import store from '@/store/index';

const actions: ActionTree<State, any> = {
  async GET_SYNTHETIC_SERVICES(
    context: { commit: Commit; rootState: any },
    params: { serviceReq: any; duration: any }
  ): Promise<any> {
    if (!params.serviceReq) {
      params.serviceReq = {
        capability: 'S'
      };
    }
    return graphQl
      .query('queryServices')
      .params(params)
      .then(async (res: AxiosResponse) => {
        if (res.data) {
          context.commit('setSyntheticServices', res.data.data.services);
        } else {
          context.commit('setSyntheticServices', []);
        }
      })
      .catch((err) => {
        context.commit('setSyntheticServices', []);
        console.log('error', err);
      });
  },
  async SELECT_SYNTHETIC_SERVICE(
    context: { commit: Commit },
    params: { key: any }
  ): Promise<any> {
    if (!params.key) {
      return;
    }
    context.commit('setCurrentSyntheticService', params);
    store.commit('globalState/app/setUpdateDasboard', params, { root: true });
  },
  async selectSMPages(
    context: { commit: Commit; dispatch: Dispatch },
    params: any
  ): Promise<any> {
    if (!params) {
      return;
    }
    context.commit('setCurrentSMPage', {
      key: params.page.id,
      label: params.page.name
    });
  }
};

export default actions;
